export interface OrganizationMembership {
  organizationGuid: string;
  name: string;
  slug: string;
  role: number;
}

export interface OrganizationContextState {
  memberships: OrganizationMembership[];
  activeOrgGuid: string | null;
  isLoading: boolean;
  error: string | null;
}

export const isOrgAdmin = (role: number) => role === 0 || role === 1;
